/** PR lane the served UI bundle was built for, or null for the shard (baseline) build. */
export function buildLane(): string | null {
  return import.meta.env.VITE_BUILD_LANE || null;
}

/** Short identity of the served UI bundle, e.g. `pr-123 @ abc1234` or `baseline @ dev`. */
export function buildLabel(): string {
  const sha = import.meta.env.VITE_BUILD_SHA;
  return `${buildLane() ?? 'baseline'} @ ${sha ? sha.slice(0, 7) : 'dev'}`;
}
